import React from 'react';
import { Button, IconButton, Paper, DialogTitle, DialogContent, DialogActions, TextField, Tooltip, Divider, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem, Stack} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, C } from '../include';
import _ from 'underscore';

class EditDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      company_id: this.props.row ? this.props.row.company_id : -1,
      procedure_id: this.props.row ? this.props.row.procedure_id : -1,
      file_id: this.props.row ? this.props.row.file_id : -1,
      session_id: (this.props.row && this.props.row.session_id) ? this.props.row.session_id : '',
      type: this.props.row ? this.props.row.type : -1,
      signed: this.props.row ? this.props.row.signed : false,
    };
  }

  handleSubmit = async () => {
console.log("1 entrou no handleSubmit");
    if (!this.props.edit) {
      this.props.api
        .post('/Docs/', { company_id: this.state.company_id, procedure_id: this.state.procedure_id, file_id: this.state.file_id, session_id: this.state.session_id, type: this.state.type, signed: this.state.signed })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Documento criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Docs/' + this.props.row.id, { company_id: this.state.company_id, procedure_id: this.state.procedure_id, file_id: this.state.file_id, session_id: this.state.session_id, type: this.state.type, signed: this.state.signed })
        .then((r) => {
console.log("3 then:",r);
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };

  
       
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Documento' : 'Adicionar Documento'}
        </DialogTitle>
        <DialogContent>
          {this.state.file_thumb && <iframe title="fileFrame" src={this.state.file_thumb} frameBorder="0" scrolling="yes" width='100%' />}
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="ID da Empresa"
            value={this.state.company_id}
            onChange={(e) => this.setState({ company_id: e.target.value })}
            required
          />         
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="ID do Procedimento"
            value={this.state.procedure_id}
            onChange={(e) => this.setState({ procedure_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="ID do Arquivo"
            value={this.state.file_id}
            onChange={(e) => this.setState({ file_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="ID da Sessão"
            value={this.state.session_id}
            onChange={(e) => this.setState({ session_id: e.target.value })}
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Tipo</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.type}
              label="Tipo"
              onChange={(e) => this.setState({type: e.target.value})}
            >
              {Object.keys(C.DocumentType).map(key => {
                  return <MenuItem key={key} value={key}>{C.DocumentType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>                         
          <D h="1rem" />
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.signed} 
              onChange={(e) => this.setState({ signed: e.target.checked })} 
            />
          } label="Documento foi assinado" />
          <D h="2rem" />
          <Stack direction="row" justifyContent="flex-end" spacing={1} >
            <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
              Cancelar
            </Button>
            <Button variant="outlined" color="primary" onClick={this.handleSubmit} disabled={this.state.invalid_cpf}>
              Salvar
            </Button>
          </Stack>
        </DialogContent>
      </form>
    );
  }
}

export class Document extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'company_id', headerName: 'Empresa', width: 90 },
      { field: 'procedure_id', headerName: 'Procedimento', width: 120 },
      { field: 'patient_id', headerName: 'Paciente', width: 100 },
      { field: 'file_id', headerName: 'Arquivo', width: 70 },
      { field: 'session_id', headerName: 'Sessão', width: 70 },
      { field: 'typestring', headerName: 'Tipo', width: 180 },
      { field: 'signed', headerName: 'Assinado', width: 100 },
      
      
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Docs', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        for(var row in r.documents){
          r.documents[row]["typestring"] = C.DocumentType[ r.documents[row]["type"] ];   
        }
        this.setState({
          dataTable: r.documents || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditDocument
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Doc/" + row.id + "/" + row.file_id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditDocument
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
